const ComplianceCDP = () => {
  return "compliance cdp not implemented";
};
export default ComplianceCDP;
